/**
 * waitingLeads — Account detail v3 AD6 (design note §45 ruling 5; spec v3 §7
 * item 2, §8): the WORDS for a lead waiting in Inbound for this account, and
 * for "Attach to this account". The server decides who is waiting (the queue
 * predicate) and does the attach; this file only says it.
 */
import type { SalesAccountWaitingLead } from '../../../../api/types'
import { daysBetween, londonDayOf } from './dealHealthCard'

/** "Inbound lead waiting 47 days" (spec §8) — whole London days since the lead
 *  arrived; "Inbound lead, arrived today" on its first day. Null when the
 *  arrival time is not a date (nothing honest to count). */
export function waitingLeadLine(createdAt: string, today: string): string | null {
  const day = londonDayOf(createdAt)
  if (!day) return null
  const d = Math.max(0, daysBetween(day, today))
  if (d === 0) return 'Inbound lead, arrived today'
  return `Inbound lead waiting ${d === 1 ? '1 day' : `${d} days`}`
}

/** The Attach button's tooltip: what the one click does, in full. */
export function attachTitle(lead: SalesAccountWaitingLead, dealName: string): string {
  const link = lead.linkedToAccount ? '' : 'links them to this account, '
  return `Attach to this account: ${link}adds ${lead.fullName} to ${dealName} and closes their Inbound lead. No new deal is created.`
}

/** The success toast. */
export function attachedToast(name: string, dealName: string): string {
  return `${name} added to ${dealName}; their Inbound lead is closed`
}
